var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHousefill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 119.375 104.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 104.188,
    opacity: 0,
    width: 119.375,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5 95.125L46.5 66.8125C46.5 64.4375 48.125 62.875 50.5 62.875L68.875 62.875C71.3125 62.875 72.8125 64.4375 72.8125 66.8125L72.8125 95.125ZM16.0625 92.8125C16.0625 99.9375 20.375 104.125 27.625 104.125L91.75 104.125C99 104.125 103.312 99.9375 103.312 92.8125L103.312 55.875L62.5625 21.75C60.8125 20.25 58.5 20.3125 56.8125 21.75L16.0625 55.875ZM4.875 53.9375C6.4375 53.9375 7.75 53.0625 8.875 52.125L58.0625 10.8125C58.5625 10.375 59.1875 10.1875 59.6875 10.1875C60.1875 10.1875 60.75 10.375 61.25 10.8125L110.5 52.125C111.625 53.0625 112.938 53.9375 114.5 53.9375C117.562 53.9375 119.375 51.75 119.375 49.4375C119.375 48.1875 118.812 46.8125 117.625 45.8125L65.9375 2.4375C63.9375 0.8125 61.8125 0 59.6875 0C57.5625 0 55.375 0.8125 53.4375 2.4375L1.75 45.8125C0.5625 46.8125 0 48.1875 0 49.4375C0 51.75 1.8125 53.9375 4.875 53.9375ZM91 25.75L104.5 37.125L104.5 14.5C104.5 12.125 102.938 10.625 100.562 10.625L94.9375 10.625C92.625 10.625 91 12.125 91 14.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousefill);
export default __webpack_public_path__ + "static/media/house.fill.fdae558853f461ba059a7f5722756c8a.svg";
export { ForwardRef as ReactComponent };